export default "__VITE_ASSET__Dvhc_wg2__"